<template>
    <div id="sponsorInfo" v-if="name">
        <div class="spons-logo-wrap">
            <img v-if="logo" :src="logo" :alt="name + ' Logo'" class="spons-logo">
        </div>
        <div class="spons-text">
            <h3>Sponsored by {{name}}</h3>
            <p v-if="message">{{message}}</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "sponsorInfo",
        props: ["name", "message", "logo"]
    };
</script>

<style scoped lang="less">
    #sponsorInfo{
        text-align: left;
        margin: 2.5rem 0;
        display: flex;
    }
    .spons-logo{
        max-width: 175px;
        height: auto;
        margin: 0 1rem 1rem 0;
    }
    .spons-text{
        margin: 0;
        flex: 1;
    }
</style>



// WEBPACK FOOTER //
// src/components/SponsorInfo.vue